interface ErrorStateProps {
  title?: string;
  message?: string;
}

export const ErrorState = ({ 
  title = "Error Loading Dashboard",
  message = "Please try refreshing the page."
}: ErrorStateProps) => (
  <div className="flex flex-col items-center justify-center min-h-[calc(100vh-4rem)]">
    <h2 className="text-2xl font-bold text-destructive mb-4">{title}</h2>
    <p className="text-muted-foreground">{message}</p>
  </div>
)
